import { FramerPage } from 'Pages/FramerPage';

const AppTeardowns = () => <FramerPage path="app-teardowns" />;

export default AppTeardowns;
